import {
  A2PRegistrationStatusInterface,
  BrandStatus,
  MessagingCampaignStatus,
  ValidationStatus,
} from '@vendasta/smsv2';
import { RegistrationStage } from './a2p-registration.constants';

export function getRegistrationStage(
  a2pRegistrationStatus: A2PRegistrationStatusInterface,
  isSubmitted: boolean,
): RegistrationStage {
  const secondaryBusinessProfileStatus =
    a2pRegistrationStatus?.secondaryBusinessProfile?.status ?? ValidationStatus.VALIDATION_STATUS_UNSPECIFIED;
  const trustBundleStatus =
    a2pRegistrationStatus?.trustBundle?.status ?? ValidationStatus.VALIDATION_STATUS_UNSPECIFIED;
  const brandStatus = a2pRegistrationStatus?.brand?.status ?? BrandStatus.BRAND_STATUS_UNSPECIFIED;
  const messagingCampaignStatus =
    a2pRegistrationStatus?.messagingCampaign?.status ?? MessagingCampaignStatus.MESSAGING_CAMPAIGN_STATUS_UNSPECIFIED;

  if (!isSubmitted) {
    return RegistrationStage.NotSubmitted;
  }

  if (
    secondaryBusinessProfileStatus === ValidationStatus.VALIDATION_STATUS_NON_COMPLIANT ||
    trustBundleStatus === ValidationStatus.VALIDATION_STATUS_NON_COMPLIANT ||
    brandStatus === BrandStatus.BRAND_STATUS_FAILED
  ) {
    return RegistrationStage.DataError;
  }

  // This is separate because the data in the form is acceptable, but it failed for other reasons outside the user's control
  if (messagingCampaignStatus === MessagingCampaignStatus.MESSAGING_CAMPAIGN_STATUS_FAILED) {
    return RegistrationStage.CampaignError;
  }

  if (messagingCampaignStatus === MessagingCampaignStatus.MESSAGING_CAMPAIGN_STATUS_VERIFIED) {
    return RegistrationStage.RegistrationComplete;
  }

  return RegistrationStage.ReviewingInfo;
}
